import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onUnmounted, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';
import PmAlertDialog from '@/components/shell/PmAlertDialog.vue';
import { Z_INDEX } from '@/config/zIndex';
import { dismissAccountDisabledNotice, subscribeAccountDisabledNotice } from '@/utils/auth-session';
export default {
  __name: 'AccountDisabledNotice',
  emits: ['shown'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const emit = __emit;
    const notice = shallowRef(null);
    const unsubscribe = subscribeAccountDisabledNotice(value => {
      notice.value = value;
      if (value) emit('shown');
    });
    onUnmounted(unsubscribe);
    function onVisibleChange(open) {
      if (!open) dismissAccountDisabledNotice();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PmAlertDialog, {
        "model-value": Boolean(notice.value),
        title: notice.value?.message || _unref(t)('authDialog.loginFailed'),
        "confirm-text": _unref(t)('markets.dialogOk'),
        "close-aria-label": _unref(t)('common.ui.close'),
        "z-index": _unref(Z_INDEX).ACCOUNT_DISABLED_ALERT,
        "onUpdate:modelValue": onVisibleChange,
        onConfirm: _unref(dismissAccountDisabledNotice)
      }, null, 8, ["model-value", "title", "confirm-text", "close-aria-label", "z-index", "onConfirm"]);
    };
  }
};